/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TChatsBulkOperationsMoveToArchiveDesktopModel,
  IChatsBulkOperationsMoveToArchiveDesktopRequest,
  IMappers,
  IChatsBulkOperationsMoveToArchiveDesktopResponse,
  IChatsBulkOperationsMoveToArchiveDesktopResponseError,
  TChatsBulkOperationsMoveToArchiveDesktopResponse,
} from './types';

const defaultConfig: TChatsBulkOperationsMoveToArchiveDesktopModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'chats',
  pathApi: '/v1/chats/bulk-operations/move-to-archive-desktop/',
  hostType: 'api',
} as TChatsBulkOperationsMoveToArchiveDesktopModel;

function createChatsBulkOperationsMoveToArchiveDesktopModel(
  parameters: IChatsBulkOperationsMoveToArchiveDesktopRequest,
): TChatsBulkOperationsMoveToArchiveDesktopModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IChatsBulkOperationsMoveToArchiveDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IChatsBulkOperationsMoveToArchiveDesktopRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchChatsBulkOperationsMoveToArchiveDesktop<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IChatsBulkOperationsMoveToArchiveDesktopOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TChatsBulkOperationsMoveToArchiveDesktopResponse
> {
  const { response, statusCode } = await httpApi.fetch(
    createChatsBulkOperationsMoveToArchiveDesktopModel(parameters),
    config,
  );

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IChatsBulkOperationsMoveToArchiveDesktopResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IChatsBulkOperationsMoveToArchiveDesktopResponseError);
    }
  }

  return { response, statusCode } as TChatsBulkOperationsMoveToArchiveDesktopResponse;
}

export {
  defaultConfig,
  createChatsBulkOperationsMoveToArchiveDesktopModel,
  fetchChatsBulkOperationsMoveToArchiveDesktop,
};
